import Hero from "../components/ui/Hero";
import Mission from "../components/ui/Mission";

const Home = () => {
  return (
    <main>
      <Hero />
      <Mission />
      {/* <FeaturedOn /> */}
      {/* <BusinessTransformations /> */}
      {/* <ValuablePartner /> */}
      {/* <WhatWeDo /> */}
      {/* <OurCommitment /> */}
    </main>
  );
};

export default Home;
